import { RootState } from 'editor/src/store/index';

import { isEmbedded } from '../../watchers/useDisplayMode';

import isAddElementsAllowed from './isAddElementsAllowed';

/**
 * GAPI-61890: the image Shape control is opt-in per host (`enableImageMask`).
 * In the embedded (buyer) editor it additionally follows the template's "Add layers"
 * switch, so a template that keeps its layers fixed does not get a new styling control.
 * Masks already in a design are always rendered; this only gates the control.
 */
const isImageMaskAllowed = (state: RootState) =>
  !!state.hostSettings.enableImageMask && (!isEmbedded || isAddElementsAllowed(state));

export default isImageMaskAllowed;
